import { AnalyticsOrigin } from "../analytics.types";
import { gaPushEvent } from "../base.analytics";

enum Event {
  VIEW_USER_PROFILE = "view_user_profile",
  VIEW_OWN_PROFILE = "view_own_profile",
  PROFILE_FOLLOW = "profile_follow",
  UPDATE_USER_INTERESTS = "update_user_interests",
  DELETE_ACCOUNT = "delete_account",
  PROFILE_SHARE = "profile_share",
  MAIN_SPECIALTY_CHANGED = "main_specialty_changed",
}

export function gaEventUserViewProfile(origin?: AnalyticsOrigin) {
  gaPushEvent(Event.VIEW_USER_PROFILE, {
    origin,
  });
}

export function gaEventUserViewOwnProfile() {
  gaPushEvent(Event.VIEW_OWN_PROFILE);
}

/**
 * A member opened the share sheet for their own profile ("Join me on Juisci",
 * the app invite). It counts the openings: the OS sheet does not report a
 * cancel on every platform.
 */
export function gaEventUserShareProfile() {
  gaPushEvent(Event.PROFILE_SHARE);
}

export function gaEventUserFollowProfile() {
  gaPushEvent(Event.PROFILE_FOLLOW);
}

export function gaEventUserUpdateInterests(
  medicalSpecialties: { uid: string }[]
) {
  gaPushEvent(Event.UPDATE_USER_INTERESTS, {
    user: {
      interests: medicalSpecialties.map((spe) => spe.uid).join(","),
    },
  });
}

export function gatEventUserDeleteAccount(userUid: string) {
  gaPushEvent(Event.DELETE_ACCOUNT, {
    user: {
      account_id: userUid,
    },
  });
}

/** The main specialty changed from the settings or the edit-profile page. */
export function gaEventMainSpecialtyChanged(change: {
  from: string | null;
  to: string;
}) {
  gaPushEvent(Event.MAIN_SPECIALTY_CHANGED, {
    previous_specialty_id: change.from,
    specialty_id: change.to,
  });
}
